import React from "react";
import { cn } from "../../../lib/utils";
import { Radio } from "../../ui/radio";
import QuestionFrame from "./QuestionFrame";

/**
 * Two-option boolean question (Yes/No or True/False).
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {boolean} [props.value]
 * @param {function(boolean): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @param {boolean} [props.showRequired]
 * @param {string} [props.trueLabel]
 * @param {string} [props.falseLabel]
 * @returns {JSX.Element}
 */
export default function BooleanQuestion({
  question,
  value,
  onChange,
  error,
  readOnly,
  showRequired,
  trueLabel = "Yes",
  falseLabel = "No",
}) {
  const name = `survey-q-${question.id}`;
  const options = [
    { id: "yes", label: trueLabel, boolValue: true },
    { id: "no", label: falseLabel, boolValue: false },
  ];
  return (
    <QuestionFrame question={question} error={error} showRequired={showRequired} indent>
      <fieldset className="m-0 space-y-1 border-0 p-0" disabled={readOnly}>
        <legend className="sr-only">{question.prompt}</legend>
        {options.map((option) => (
          <label
            key={option.id}
            className={cn(
              "flex items-center gap-3 rounded-md py-2 transition-colors",
              readOnly ? "cursor-default" : "cursor-pointer hover:bg-ui-muted/50"
            )}
          >
            <Radio
              name={name}
              value={option.id}
              checked={value === option.boolValue}
              disabled={readOnly}
              onSelect={() => onChange(option.boolValue)}
              aria-label={option.label}
            />
            <span className="text-sm text-text-primary">{option.label}</span>
          </label>
        ))}
      </fieldset>
    </QuestionFrame>
  );
}
